import { Node } from '@tiptap/core'

const ALLOWED = ['black', 'grey', 'pink', 'blue']

export const DrawRule = Node.create({
  name: 'drawRule',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      dashed: { default: false },
      color: { default: null }, // 'black' | 'grey' | 'pink' | 'blue' | null
    }
  },

  parseHTML() {
    return [
      {
        tag: 'hr',
        getAttrs: el => {
          const cls = el.getAttribute('class') || ''
          if (!/\bdraw\b/.test(cls)) return false
          return {
            dashed: /\bdashed\b/.test(cls),
            color: (cls.match(/\b(black|grey|pink|blue)\b/) || [null, null])[1],
          }
        },
      },
    ]
  },

  renderHTML({ node }) {
    const classes = ['draw', 'space']
    if (node.attrs.dashed) classes.push('dashed')
    if (node.attrs.color && ALLOWED.includes(node.attrs.color)) classes.push(node.attrs.color)
    return ['hr', { class: classes.join(' ') }]
  },

  addCommands() {
    return {
      insertDrawRule:
        (opts = { dashed: false, color: null }) =>
        ({ chain }) =>
          chain()
            .insertContent({ type: this.name, attrs: { dashed: !!opts.dashed, color: opts.color ?? null } })
            .run(),

      setHRColor:
        (color = null) =>
        ({ state, commands }) => {
          const n = state.selection?.node
          if (!n || n.type?.name !== this.name) return false
          const c = ALLOWED.includes(String(color)) ? String(color) : null
          return commands.updateAttributes(this.name, { color: c })
        },

      toggleHRDashed:
        () =>
        ({ state, commands }) => {
          const n = state.selection?.node
          if (!n || n.type?.name !== this.name) return false
          return commands.updateAttributes(this.name, { dashed: !n.attrs.dashed })
        },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Shift-h': () => this.editor.commands.insertDrawRule({ dashed: false }),
      'Mod-Alt-Shift-h': () => this.editor.commands.insertDrawRule({ dashed: true }),
    }
  },
})
